import { IAppConfigActionType, eAppConfigActionTypeIds } from "../../action-types/common/IAppConfigActionType";
import { IAppConfigReducer } from "../../reducer-model/common/appConfigReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IAppConfigReducer = {
    status: eReducerStatusBase.is_not_initialization,
}
export const appConfigReducer = (state: IAppConfigReducer = iniState, action: IAppConfigActionType): IAppConfigReducer => {
    switch (action.type) {
        case eAppConfigActionTypeIds.LOAD_START:
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case eAppConfigActionTypeIds.LOAD_SUCCESS:
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                appConfig: action.payload
            }
        case eAppConfigActionTypeIds.LOAD_ERROR:
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        default:
            return {
                ...state
            }
    }
}